import React, { useRef, useState, useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useNavigate, Link } from 'react-router-dom';
import logo from '../../assets/Specs_Logo.png';
import calculatorIcon from '../../assets/icon_calculator.svg';
import toolsIcon from '../../assets/icon-tools.svg';
import Tooltip from '../modules/Tooltip';
import TextField from '../modules/TextField';
import IconButton from '../modules/IconButton';
import Button from '../modules/Button';
import { WidthContext } from '../../contexts/WidthContextProvider';
import Icon from '../modules/Icon';
import DOMPurify from 'dompurify';// SIP-541A: Import DOMPurify for input sanitization

const TopNav = ({ isSearchPanelOpen, setSearchPanelOpen, handleMobileMenu }) => {
    const { isMobile } = useContext(WidthContext);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const searchInput = useRef(null);

    // SIP-541B: Refactor handleSubmit to include sanitization and empty input validation
    const handleSubmit = () => {
        // SIP-541B: Trim whitespace from the search term
        const trimmedSearchTerm = searchTerm.trim();
        // SIP-541B: If the trimmed search term is empty, do not proceed with submission
        if (trimmedSearchTerm === '') {
            // Optionally, you could provide user feedback here (e.g., set an error state)
            console.log('Search term is empty, not submitting.');
            return;
        }
        // SIP-541A: Sanitize the search term to prevent malicious code injection
        const sanitizedSearchTerm = DOMPurify.sanitize(trimmedSearchTerm);

        // Replace spaces with hyphens for the URL, similar to original logic
        const _searchTerm = sanitizedSearchTerm.replace(/ /g, '-'); // Use regex with 'g' for global replacement

        navigate(`/search-results/${_searchTerm}`);
        setSearchTerm(''); // Clear the search term after submission
    };
    // SIP-541B: Modify handleSearchIconClick to leverage handleSubmit's built-in validation
    const handleSearchIconClick = () => {
        // If searchTerm is empty, focus the input. Otherwise, attempt submission.
        // handleSubmit will now handle the empty string validation.
        if (searchTerm.trim() === '') { // SIP-541B: Check trimmed searchTerm
            searchInput.current.focus();
        } else {
            handleSubmit();
        }
    };
    // SIP-541C: Add a handler for TextField's onChange to sanitize input as it's typed.
    const handleSearchInputChange = (e) => {
        // Sanitize input as it's typed, before setting state
        const sanitizedInput = DOMPurify.sanitize(e.target.value);
        setSearchTerm(sanitizedInput);
    };
    return (
        <>
            {
                isMobile
                    ? (
                        <>
                            <div className='SideNav__icons flex'>
                                <div className='SideNav__logo'>
                                    <Link to='/'>
                                        <img src={logo} alt='Walt Disney Tech' />
                                    </Link>
                                </div>
                                <div className='flex'>
                                    {/* SIP-541B: handleSearchIconClick logic for mobile search panel toggle */}
                                    <IconButton className='TopNav__mobile' name='search' onClick={() => setSearchPanelOpen(!isSearchPanelOpen)} />
                                    <IconButton className='SideNav__menu pointer flex' name='menu' onClick={handleMobileMenu} />
                                </div>
                            </div>
                        </>
                    )
                    : (
                        <>
                            <div className='SideNav__logo'>
                                <Link to='/'>
                                    <img className='flex' src={logo} alt='Walt Disney Tech' />
                                </Link>
                            </div>

                            <div className='TopNav flex align-center'>
                                <Tooltip content='Search' direction='down'>
                                    <Icon name='search' className='Top' onClick={handleSearchIconClick} />
                                    <TextField
                                        ref={searchInput}
                                        placeholder='Search Specs ...'
                                        className='TopNav__Search'
                                        padded={false}
                                        // SIP-541C: Use the new sanitized change handler
                                        onChange={handleSearchInputChange}
                                        value={searchTerm}
                                        onSubmit={handleSubmit} // TextField's onSubmit will call handleSubmit on Enter key
                                    />
                                </Tooltip>
                                <div className='flex'>
                                    <Tooltip content='Calculators' direction='down'>
                                        <Link className='TopNav__calc_icon' to='/calculators'>
                                            <img src={calculatorIcon} alt='calculator icon' />
                                        </Link>
                                    </Tooltip>
                                    <Tooltip content='ToolBox' direction='down'>
                                        <Link className='TopNav__calc_icon' to='/tools'>
                                            <img src={toolsIcon} alt='ToolBox' />
                                        </Link>
                                    </Tooltip>
                                    <Tooltip content='Glossary' direction='down'>
                                        <IconButton name='book' className='TopNav__book' link='/glossary' />
                                    </Tooltip>
                                    <Tooltip content='Contact Us' direction='down'>
                                        <IconButton name='email' link='/contact' />
                                    </Tooltip>
                                </div>

                            </div>
                        </>)
            }

            {/* SIP-541B: Ensure mobile search panel also uses new validation logic */}
            {!isSearchPanelOpen && isMobile &&
                <div className='SideNav__search__container'>
                    <TextField
                        ref={searchInput}
                        placeholder='Type to Search...'
                        icon='search'
                        className='TopNav__Search mobile'
                        padded={false}
                        // SIP-541C: Use the new sanitized change handler for mobile TextField
                        onChange={handleSearchInputChange}
                        value={searchTerm}
                        onSubmit={handleSubmit} // TextField's onSubmit will call handleSubmit on Enter key
                    />
                    <hr className='SideNav__divider' />
                    {/* SIP-541B: Button onClick now directly calls handleSubmit */}
                    <Button className='TopNav__button' onClick={handleSubmit} text='Search' type='surface' />
                </div>}
        </>
    );
};

TopNav.propTypes = {
    isSearchPanelOpen: PropTypes.bool,
    setSearchPanelOpen: PropTypes.func,
    handleMobileMenu: PropTypes.func
};

export default TopNav;